import template   from './products-basket.html'
import controller from './products-basket.controller'

let component = {
  restrict: 'E',
  bindings: {
    product: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products-basket/products-basket.component.js